<template>
  <div class="eda-dashboard">
    <EmbeddedBreadcrumbBar :items="breadcrumbItems" />
    <EdaWorkspace :analysis-id="analysis" :tenant-id="tenantId" />
  </div>
</template>
<script>
import EmbeddedBreadcrumbBar from "@/components/layout/Common/EmbeddedBreadcrumbBar.vue";
import EdaWorkspace from "@/features/eda/components/EdaWorkspace.vue";
import { buildEdaBreadcrumbItems } from "@/utils/edaAnalysisTitles";
import { getTenantPrefixFromRoute } from "@/utils/tenant";

export default {
  name: "EDADashboard",
  components: {
    EmbeddedBreadcrumbBar,
    EdaWorkspace,
  },
  computed: {
    tenantId() {
      return getTenantPrefixFromRoute(this.$route);
    },
    analysis() {
      return this.$route.params.analysis || "inventory-analysis";
    },
    breadcrumbItems() {
      return buildEdaBreadcrumbItems(this.tenantId, this.analysis);
    },
  },
};
</script>
